/**
 * /config endpoint-аас apiBaseUrl-ыг авна. Анхны дуудлагад cache-лнэ.
 */
interface AppConfig {
  apiBaseUrl: string;
}

let cachePromise: Promise<AppConfig> | null = null;

export function loadConfig(): Promise<AppConfig> {
  if (!cachePromise) {
    const envBase = import.meta.env.VITE_API_BASE_URL as string | undefined;
    if (envBase) {
      cachePromise = Promise.resolve({ apiBaseUrl: envBase });
    } else {
      cachePromise = fetch('/config', { headers: { Accept: 'application/json' } })
        .then((r) => {
          if (!r.ok) throw new Error('config fetch failed: ' + r.status);
          return r.json() as Promise<AppConfig>;
        })
        .catch((err) => {
          cachePromise = null;
          throw err;
        });
    }
  }
  return cachePromise;
}
